// Test IDs for the calendar workspace.
export const CAL = {
  container: 'calendar-workspace',
  topBar: 'calendar-top-bar',
  todayButton: 'calendar-today-button',
  prevButton: 'calendar-prev-button',
  nextButton: 'calendar-next-button',
  viewSelector: 'calendar-view-selector',
  clinicFilter: 'calendar-clinic-filter',
  audiologistFilter: 'calendar-audiologist-filter',
  createAppointmentButton: 'calendar-create-appointment-button',
  searchInput: 'calendar-search-input',
  canvas: 'calendar-canvas',
  metricsHeader: 'calendar-metrics-header',
  metric: (name) => `metric-${name}`,
  appointmentChip: (id) => `appointment-chip-${id}`,
  timeSlot: (day, hour) => `time-slot-${day}-${hour}`,
  drawer: 'appointment-drawer',
  drawerClose: 'appointment-drawer-close',
  drawerTab: (name) => `drawer-tab-${name}`,
  drawerAction: (name) => `drawer-action-${name}`,
  transitionButton: (state) => `transition-to-${state}`,
  dailyOpsPanel: 'daily-operations-panel',
  createDialog: 'create-appointment-dialog',
  createDialogSubmit: 'create-appointment-submit',
};

export const ADMIN = {
  page: 'admin-page',
  tab: (name) => `admin-tab-${name}`,
  createButton: (name) => `admin-create-${name}-button`,
  saveButton: 'admin-save-button',
  deleteButton: (id) => `admin-delete-${id}`,
  row: (id) => `admin-row-${id}`,
};

export const NAV = {
  logo: 'nav-logo',
  calendarLink: 'nav-calendar-link',
  adminLink: 'nav-admin-link',
  userMenu: 'nav-user-menu',
  logoutButton: 'nav-logout-button',
};
